import getHref from './getHref';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { assert } from '../../utils';
export default function useLinkProps(href, to, inNewTab) {
    const history = useHistory();
    assert(Boolean(history) || !to || inNewTab, 'This component cannot have the "to" prop unless it is inside a <Router> element');
    const handleRouteClick = useCallback((event) => {
        event.preventDefault();
        history.push(to);
    }, [to, history]);
    const actualHref = getHref(href, to, history);
    if (!actualHref)
        return undefined;
    if (inNewTab) {
        return {
            href: actualHref,
            target: '_blank',
            rel: 'noopener noreferrer',
        };
    }
    if (href)
        return { href: actualHref };
    if (to) {
        return {
            href: actualHref,
            onClick: handleRouteClick,
        };
    }
}
//# sourceMappingURL=useLinkProps.js.map